<template>
  <div class="grid-view">
    <div class="main-content">
      <!--按钮-->
      <div style="margin-top: 5px">
        <el-button v-if="!isDialog && isEdit && canUpdate" type="primary" no="Cancel" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        <el-button v-if="!isDialog && isEdit && canUpdate" type="primary" no="Save" @click="save">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button v-if="!isDialog && !isEdit" type="primary" no="Back" @click="$emit('back')">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
        <el-button v-if="!isDialog && !isEdit && canUpdate" :disabled="form.status2 === SystemConstants.QUOTE_STATUS_QUOTED.code" type="primary" no="Edit" @click="edit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
        <el-button v-if="!isDialog && canUpdate" :disabled="isEdit || form.status2 === SystemConstants.QUOTE_STATUS_QUOTED.code" type="primary" no="submit" @click="editStatus(SystemConstants.QUOTE_ACTION_SUBMIT.code)">{{ $t('CargoMsg.Cargo_SubmitQuotation') }}</el-button>
        <el-button v-if="!isDialog && canUpdate" :disabled="isEdit || form.status2 === SystemConstants.QUOTE_STATUS_PENDING.code" type="primary" no="revoke" @click="editStatus(SystemConstants.QUOTE_ACTION_REVOKE.code)">{{ $t('CargoMsg.Cargo_WithdrawQuotation') }}</el-button>
        <el-button v-if="!isDialog && canUpdate" :disabled="isEdit || form.status2 !== SystemConstants.QUOTE_STATUS_PENDING.code" type="primary" no="refuse" @click="p => { refuseQuotationDialog.visible = true }">{{ $t('CargoMsg.Cargo_RejectQuotation') }}</el-button>
        <span style="font-size:14px;">
          {{ form.quotationNo }}
        </span>
        <span no="status" style="font-size:14px;color:red;margin-left: 5px">
          {{ ColumnUtils.showTypeLabelFunc(form.status2, SystemConstants.QUOTE_STATUS) + (form.refuseReason ? ('(' + form.refuseReason + ')') : '') }}
        </span>
      </div>
      <div>
        <!--基本信息-->
        <el-form
          disabled
          class="quotation-pre-port-form"
          style="margin-top: 5px;display: flex;flex-wrap: wrap"
          label-width="120px"
          label-position="right"
        >
          <!--委托单位-->
          <!--正式客户-->
          <!--          <el-form-item-->
          <!--            v-if="form.customerIdType === SystemConstants.CUSTOMER_ID_TYPE_OFFICIAL.code"-->
          <!--            :label="$t('SeaExport.ConsignationCompany')"-->
          <!--          >-->
          <el-form-item
            :label="$t('SeaExport.ConsignationCompany')"
          >
            <cargo-sales-company-select
              no="clientId"
              :method-params="{customer:true,active:true}"
              :default-value="Number(form.clientId || 0)"
              @parentCallBack="p=>{form.clientId = p.cmpIdx + ''}"
            />
          </el-form-item>
          <!--临时客户-->
          <el-form-item
            v-if="form.customerIdType === SystemConstants.CUSTOMER_ID_TYPE_TEMPORARY.code"
            :label="$t('SeaExport.Addr')"
            required
          >
            <el-input :value="form.address" />
          </el-form-item>
          <!--关联查询询价单中的信息即可-->
          <!--询价编号-->
          <el-form-item :label="$t('CargoMsg.Cargo_EnquiryNumber')">
            <el-input :value="form.inquiryPriceNo" disabled />
          </el-form-item>
          <!--询价人-->
          <el-form-item :label="$t('CargoMsg.Cargo_Enquirer')">
            <cargo-user-select
              :default-value="form.inquiryCreatedBy"
              disabled
            />
          </el-form-item>
          <!--货盘性质-->
          <el-form-item :label="$t('CargoMsg.Cargo_PalletType')" required>
            <cargo-advance-select
              no="palletNature"
              tag-value="code"
              filterable
              :clearable="false"
              :default-value="form.palletNature"
              :static-options="SystemConstants.PALLET_NATURES"
              @parentCallBack="p=>{form.palletNature=p.value}"
            />
          </el-form-item>
          <!--货好时间-->
          <el-form-item :label="$t('SeaExport.CargoReadyDate')" required>
            <el-tabs v-model="form.cargoReadyTimeType">
              <el-tab-pane disabled :label="$t('CargoMsg.Cargo_Range')" :name="SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code" />
              <el-tab-pane disabled :label="$t('CargoMsg.Cargo_Date')" :name="SystemConstants.CARGO_READY_TIME_TYPE_DATE.code" />
            </el-tabs>
            <cargo-advance-select
              v-if="form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code"
              no="cargoReadyTimeRange"
              tag-value="code"
              filterable
              :clearable="false"
              :default-value="form.cargoReadyTimeRange"
              :static-options="SystemConstants.CARGO_READY_TIME_RANGES"
              @parentCallBack="p=>{form.cargoReadyTimeRange=p.value}"
            />
            <el-date-picker
              v-if="form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_DATE.code"
              v-model="form.cargoReadyTimeDate"
              no="cargoReadyTimeDate"
              type="datetime"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <!--服务条款-->
          <el-form-item :label="$t('CargoMsg.Cargo_Terms')">
            <cargo-advance-select
              no="serviceTerm"
              filterable
              :select-type="TYPE_NAMES.basic_data_IncoTerm"
              callback-method-type="value"
              :default-value="form.serviceTerm"
              :callback-params="{key:'incoTerm'}"
              @parentCallBack="p => form.serviceTerm = p.value"
            />
          </el-form-item>
          <!--直达/中转-->
          <el-form-item :label="$t('CargoMsg.Cargo_DirectOrTransshipment')" required>
            <cargo-advance-select
              no="directTransit"
              tag-value="code"
              filterable
              :clearable="false"
              :default-value="form.directTransit"
              :static-options="SystemConstants.DIRECT_TRANSITS"
              @parentCallBack="p=>{form.directTransit=p.value}"
            />
          </el-form-item>
          <!--中转港-->
          <el-form-item
            v-if="form.directTransit === SystemConstants.DIRECT_TRANSIT_TRANSIT.code"
            :label="$t('SeaExport.TransitPort')"
            required
          >
            <cargo-advance-select
              :select-type="TYPE_NAMES.basic_data_Seaport"
              filterable
              :default-value="form.transferPortCode"
              style="width:100%"
              @parentCallBack="p=>form.transferPortCode=p.value"
            />
          </el-form-item>
          <!--航线-->
          <el-form-item :label="$t('CargoMsg.Cargo_Airline')" required>
            <cargo-advance-select
              :select-type="TYPE_NAMES.basic_data_Region"
              filterable
              :default-value="form.commerceCode"
              style="width:100%"
              @parentCallBack="p=>{form.commerceCode=p.value;}"
            />
          </el-form-item>
          <!--起运港-->
          <el-form-item :label="$t('CargoMsg.Cargo_POL')" required>
            <el-input :value="ColumnUtils.getSeaAirPortLabel(form.pol)" />
          </el-form-item>
          <!--卸货港-->
          <el-form-item :label="$t('CargoMsg.Cargo_PortOfDischarge')" required>
            <el-input :value="ColumnUtils.getSeaAirPortLabel(form.pod)" />
          </el-form-item>
          <!--货物类型-->
          <el-form-item :label="$t('SeaExport.CargoType')">
            <cargo-advance-select
              no="cargoType"
              filterable
              :select-type="TYPE_NAMES.basic_data_CargoType"
              callback-method-type="value"
              :default-value="form.cargoType"
              :callback-params="{key:'cargoType'}"
              @parentCallBack="p => form.cargoType = p.value"
            />
          </el-form-item>
          <!--危险品等级-->
          <el-form-item
            v-if="form.cargoType === ImportConstants.CARGOTYPE_DANGEROUS.code"
            :label="$t('SeaExport.DangerousClass')"
            required
          >
            <cargo-advance-select
              no="dangerousGoodsLevel"
              tag-value="code"
              filterable
              :clearable="false"
              :default-value="form.dangerousGoodsLevel"
              :static-options="SystemConstants.DANGEROUS_GOODS_LEVELS"
              @parentCallBack="p=>{form.dangerousGoodsLevel=p.value}"
            />
          </el-form-item>
          <!--UN NO 4位整数-->
          <el-form-item
            v-if="form.cargoType === ImportConstants.CARGOTYPE_DANGEROUS.code"
            label="UN NO"
            required
          >
            <el-input-number
              v-model="form.unNo"
              no="unNo"
              controls-position="right"
              :precision="0"
              :min="0"
              :max="9999"
            />
          </el-form-item>
          <!--长宽高-->
          <el-form-item
            v-if="form.cargoType === ImportConstants.CARGOTYPE_OOG.code"
            :label="$t('CargoMsg.Cargo_Dimensions')"
            class="length-weight-height"
            required
          >
            <cargo-length-width-height
              style="width: 300px"
              :form="form"
            />
          </el-form-item>
          <!--温度-->
          <el-form-item
            v-if="form.cargoType === ImportConstants.CARGOTYPE_FROZEN.code"
            :label="$t('SeaExport.Temperature')"
            class="with-unit"
            required
          >
            <el-input-number
              v-model="form.temperature"
              no="temperature"
              controls-position="right"
              :precision="0"
            />
            <span>℃</span>
          </el-form-item>
          <!--通风量-->
          <el-form-item
            v-if="form.cargoType === ImportConstants.CARGOTYPE_FROZEN.code"
            :label="$t('SeaExport.VentilationQuantity')"
            class="with-unit"
            required
          >
            <el-input-number
              v-model="form.ventilationQuantity"
              no="ventilationQuantity"
              controls-position="right"
              :precision="0"
            />
            <span>%</span>
          </el-form-item>
          <!--品名（HS Code）-->
          <el-form-item :label="$t('CargoMsg.Cargo_NameHSCode')" required>
            <el-input :value="form.goodsName" />
          </el-form-item>
          <!--重量-->
          <el-form-item class="with-unit" :label="$t('CargoMsg.Cargo_Weight')" required>
            <el-input-number
              v-model="form.grossWeight"
              no="weight"
              controls-position="right"
              :disabled="true"
              :precision="2"
              :min="0"
            />
            <span>KGS</span>
          </el-form-item>
          <!--船公司-->
          <el-form-item :label="$t('SeaExport.ShippingCompany')">
            <cargo-advance-select
              no="carrierId"
              filterable
              :select-type="TYPE_NAMES.basic_data_Company"
              :method-params="{seaCmp:true,active:true}"
              :default-value="form.carrierId || ''"
              placeholder=" "
              @parentCallBack="p => form.carrierId=p.value"
            />
          </el-form-item>
          <!--备注-->
          <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
            <el-input :value="form.remarks" />
          </el-form-item>
          <!--20GP数量-->
          <el-form-item :label="$t('CargoMsg.Cargo_20GPQuantity')">
            <el-input-number
              v-model="form.num20"
              no="gp20Num"
              :min="0"
              :precision="0"
              controls-position="right"
              style="width: 300px"
            />
          </el-form-item>
          <!--40GP数量-->
          <el-form-item :label="$t('CargoMsg.Cargo_40GPQuantity')">
            <el-input-number
              v-model="form.num40"
              no="gp40Num"
              :min="0"
              :precision="0"
              controls-position="right"
              style="width: 300px"
            />
          </el-form-item>
          <!--40HC数量-->
          <el-form-item :label="$t('CargoMsg.Cargo_40HCQuantity')">
            <el-input-number
              v-model="form.numHc"
              no="hc40Num"
              :min="0"
              :precision="0"
              controls-position="right"
              style="width: 300px"
            />
          </el-form-item>
          <!--45HC数量-->
          <el-form-item :label="$t('CargoMsg.Cargo_45HCQuantity')">
            <el-input-number
              v-model="form.num45"
              no="hc45Num"
              :min="0"
              :precision="0"
              controls-position="right"
              style="width: 300px"
            />
          </el-form-item>
          <!--20NOR数量-->
          <el-form-item :label="$t('CargoMsg.Cargo_20NORQuantity')">
            <el-input-number
              v-model="form.num20Nor"
              no="nor20Num"
              :min="0"
              :precision="0"
              controls-position="right"
              style="width: 300px"
            />
          </el-form-item>
          <!--40NOR数量-->
          <el-form-item :label="$t('CargoMsg.Cargo_40NORQuantity')">
            <el-input-number
              v-model="form.num40Nor"
              no="nor40Num"
              :min="0"
              :precision="0"
              controls-position="right"
              style="width: 300px"
            />
          </el-form-item>
          <!--装箱门点/起运地区域-->
          <el-form :inline="true" disabled style="width: 880px" label-position="right" class="form-item-200">
            <cargo-area
              class="area"
              no="city"
              country="CN"
              :province.sync="form.province"
              :city.sync="form.city"
              :district.sync="form.districts"
              :town.sync="form.townUuid"
              :show-town="true"
              :select-width="165"
              style="display: inline-block"
            />
          </el-form>
          <!--详细地址 -->
          <el-form-item
            :label="$t('Partners.detailAddress')"
          >
            <el-input v-model="form.detailAddress" style="width: 300px" type="textarea" :rows="3" />
          </el-form-item>
          <!--运输方式-->
          <el-form-item style="margin-left: 20px" :label="$t('SeaExport.transportation')" required>
            <el-radio-group v-model="form.transportMode" style="width: 300px">
              <el-radio :label="SystemConstants.PRICE_METHOD_DIRECT.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_DirectHaul') }}</el-radio>
              <el-radio :label="SystemConstants.PRICE_METHOD_BRANCH.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_SideLine') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--支线类型-->
          <el-form-item
            v-if="form.transportMode === SystemConstants.PRICE_METHOD_BRANCH.code"
            :label="$t('CargoMsg.Cargo_SideLineType')"
            required
          >
            <cargo-advance-select
              no="branchLine"
              tag-value="code"
              filterable
              style="width:300px"
              :clearable="false"
              :default-value="form.branchLine"
              :static-options="SystemConstants.BRANCH_LINES"
              @parentCallBack="p=>{form.branchLine=p.value}"
            />
          </el-form-item>
        </el-form>
        <!--运价信息-->
        <div class="section" style="width:100%">
          <span class="title">{{ $t('Pricing.PriceInfo') }}</span>
          <div>
            <el-button :disabled="!isEdit" no="onAddC" type="primary" style="margin-left: 10px;" @click="addQuotationDetail">{{ $t('Pricing.Add') }}</el-button>
            <el-button :disabled="!isEdit" no="onDeleteC" type="danger" @click="delQuotationDetail">{{ $t('Pricing.Delete') }}</el-button>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid-wrapper
              config-module="2025050282"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="form.prePortLastMileDetails"
              :show-selected-color="false"
              :check-sub-record="false"
              style="height: 100%;"
              @gridReady="params=>{gridApi=params.api}"
            />
          </div>
        </div>
        <!--费用信息-->
        <div class="section" style="width:100%">
          <!--按箱型计费条目-->
          <span>{{ $t('CargoMsg.Cargo_ChargeByContainerType') }}</span>
          <div>
            <el-button :disabled="!isEdit" type="primary" @click="addChargingItem(SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code)">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button :disabled="!isEdit" type="danger" @click="delChargingItem(SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code)">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid-wrapper
              config-module="2025050283"
              :grid-options="chargingItemByEqSize.gridOptions"
              :column-defs="getColumnDefsByEqSize"
              :row-data="selectedRow ? selectedRow.byEqSizeChargingItems : []"
              :show-selected-color="false"
              :check-sub-record="false"
              style="height: 100%;"
              @gridReady="params=>{chargingItemByEqSize.gridApi=params.api}"
            />
          </div>
          <!--非按箱型计费条目-->
          <span>{{ $t('CargoMsg.Cargo_ChargeNotByContainerType') }}</span>
          <div>
            <el-button :disabled="!isEdit" type="primary" @click="addChargingItem(SystemConstants.CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code)">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button :disabled="!isEdit" type="danger" @click="delChargingItem(SystemConstants.CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code)">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid-wrapper
              config-module="2025050284"
              :grid-options="chargingItemNotByEqSize.gridOptions"
              :column-defs="getColumnDefsNotByEqSize"
              :row-data="selectedRow ? selectedRow.notByEqSizeChargingItems : []"
              :show-selected-color="false"
              :check-sub-record="false"
              style="height: 100%;"
              @gridReady="params=>{chargingItemNotByEqSize.gridApi=params.api}"
            />
          </div>
        </div>
        <!--文件历史-->
        <div v-if="form && form.uuid" class="section" style="width:100%">
          <span class="title">{{ $t('Pricing.FileHistory') }}</span>
          <el-form v-if="isEdit" class="section">
            <el-row>
              <el-col :span="24">
                <el-button no="toFileQuery" type="primary" @click="toFileQuery">{{ $t('FileHistory.Refresh') }}</el-button>
                <el-button v-permission="['button_FileHistory_fileUpload']" no="upload" type="primary" @click="file.cloudFile.visible=true">{{ $t('FileHistory.Upload') }}</el-button>
                <el-button v-permission="['button_FileHistory_fileDelete', 'role_FileDownloads_ownFileDelete']" no="fileRemove" type="danger" @click="fileRemove">{{ $t('FileHistory.Delete') }}</el-button>
                <el-button no="fileDownload" type="primary" @click="fileDownload">{{ $t('FileHistory.BatchDownload') }}</el-button>
                <el-button no="fileSendEmail" type="primary" @click="fileSendEmail">{{ $t('FileHistory.SendEmail') }}</el-button>
              </el-col>
            </el-row>
          </el-form>
          <el-form class="section" :disabled="!isEdit">
            <el-row>
              <el-col :span="24">
                <cargo-ag-grid
                  key="25070802"
                  config-module="25070802"
                  :grid-params.sync="file.gridParams"
                  :grid-options="file.gridOptions"
                  :column-defs="file.columnDefs"
                  :row-data="file.rowData"
                  style="flex: 1"
                  @gridReady="params=>{file.gridApi=params.api}"
                />
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="file.cloudFile.visible"
      :job="fileCloudFileJob"
      :lob="file.cloudFile.lob"
      @uploadDone="toFileQuery"
    />

    <!-- 文件-属性详情 -->
    <el-dialog
      v-if="file.isShowingDetailForm"
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible="file.isShowingDetailForm"
      :title="file.showDetailTitle"
      width="450px"
      @close="() => file.isShowingDetailForm = false"
    >
      <cargo-ag-grid
        :grid-options="file.gridOptionsFileDetail"
        :column-defs="file.columnDefsFileDetail"
        :row-data="file.rowDataFileDetail"
        style="width:400px;height: 300px"
        @gridReady="params=>file.gridApiFileDetail=params.api"
      />
    </el-dialog>

    <!-- 发送邮件弹窗 -->
    <send-email-dialog
      v-if="file.sendEmailDialog.visible"
      ref="file.sendEmailDialog"
      :visible.sync="file.sendEmailDialog.visible"
      :context="null"
      :job="fileCloudFileJob"
      source="quotationDetailDialog"
      :send-email-data="file.sendEmailDialog"
    />

    <!-- 拒绝报价弹框 -->
    <el-dialog
      no="refuseQuotationDialog"
      :visible.sync="refuseQuotationDialog.visible"
      :title="$t('CargoMsg.Cargo_Tips')"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      @close="refuseQuotationDialog.visible = false"
    >
      <el-form label-width="70px" label-position="right">
        <div style="margin-left: 230px;margin-top: 5px;margin-bottom: 5px;font-size: larger;">{{ $t('CargoMsg.Cargo_ConfirmRejectQuote') }}</div>
        <el-form-item :label="$t('Partners.RefuseRemark') + ':'">
          <el-input
            v-model="refuseQuotationDialog.refuseReason"
            no="refuseReason"
            type="textarea"
            :rows="6"
            style="width: 450px"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button no="confirm" type="primary" @click="editStatus(SystemConstants.QUOTE_ACTION_REFUSE.code)">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="cancel" @click="p => {refuseQuotationDialog.refuseReason = '';refuseQuotationDialog.visible=false}">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FileHistoryHp from '@/views/cargo/v0/Files/FileHistory/FileHistoryHp'
import { DocumentManage } from '@/utils/commonUtil'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import sendEmailDialog from '@/components/Cargo/Job/sendEmailDialog'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import QuotationPrePortLastMileDetail from '@/components/Cargo/Quotation/quotationPrePortLastMileDetail'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { Quotation } from '@/class/model/price/Quotation'
import cargoArea from '@/components/Cargo/Common/cargoArea'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor/index'
import cargoLengthWidthHeight from '@/components/Cargo/Common/cargoLengthWidthHeight'
import $store from '@/store'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { PRICE_METHOD_BRANCH, PRICE_METHOD_DIRECT } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'QuotationPrePortDetail', // 港前运价-详情
  components: { cargoCloudFileUpload, sendEmailDialog, CargoSalesCompanySelect, cargoLengthWidthHeight, cargoAgGridWrapper, cargoAdvanceSelect, cargoCompanySelect, QuotationPrePortLastMileDetail, cargoUserSelect, cargoArea },
  props: {
    isEditAll: {
      type: Boolean,
      default: () => false
    },
    isDialog: { type: Boolean, default: false } // 详情 是否 作为弹窗
  },
  data() {
    return {
      refuseQuotationDialog: { // 拒绝原因 弹窗
        visible: false,
        refuseReason: ''
      },
      fileHistoryHp: new FileHistoryHp(this),
      documentManage: new DocumentManage(),
      file: {
        queryKey: 'prePortQuotationUuid',
        docType: [],
        fileName: '',
        fileIdList: '',
        storageURL: '',
        fileTypeMap: new Map(),
        cloudFile: {
          visible: false,
          job: new Quotation(),
          lob: ''
        },
        sendEmailDialog: {
          visible: false,
          emailTitle: '',
          emailContent: '',
          detailCode: '',
          fileIdList: '',
          fileList: []
        },
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          // 选中 文件类型
          onCellFocused: (event) => {
            FileHistoryHp.onFileTypeCellFocused(event, this)
          },
          treeData: true,
          getDataPath: data => {
            return (data.path || '').split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('FileHistory.fileName'),
            field: 'fileName',
            width: 240,
            headerCheckboxSelection: false,
            valueFormatterParams: {
              suppressCount: true,
              suppressDoubleClickExpand: false,
              checkbox: params => {
                return false
              }
            }
          }
        },
        gridParams: {},
        gridApi: null,
        columnDefs: [
          {
            headerName: '',
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 55,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('FileHistory.fileVersion'),
            field: 'fileVersion',
            width: 200
          },
          {
            headerName: this.$t('FileHistory.jobType'),
            field: 'fileType',
            width: 200,
            valueFormatter: params => {
              return FileHistoryHp.fileTypeLabelFunction(params.value, this)
            }
          },
          {
            headerName: this.$t('FileHistory.fileType'),
            field: 'fileFormat',
            width: 200
          },
          {
            headerName: this.$t('FileHistory.fileSize'),
            field: 'fileSize',
            width: 200,
            valueFormatter: params => {
              return FileHistoryHp.fileSizeColumnLabel(params.value, this)
            }
          },
          {
            headerName: this.$t('FileHistory.createdBy'),
            field: 'createdBy',
            width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
            }
          },
          {
            headerName: this.$t('FileHistory.createdDate'),
            field: 'createDate',
            width: 200
          },
          {
            headerName: this.$t('FileHistory.Details'),
            field: 'fileId',
            width: 200,
            cellRenderer: params => {
              const methodPath = this.documentManage.getPath('popFileHistoryDetailFormDialog')
              return `<a onclick="${methodPath}('${params.value}')" style="color:blue">${this.$t('FileHistory.Details')}</a>`
            }
          },
          {
            headerName: this.$t('FileHistory.view'),
            field: 'fileId',
            width: 200,
            cellRenderer: params => {
              const methodOnFileViewPath = this.documentManage.getPath('onFileView')
              return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:blue">${this.$t('FileHistory.view')}</a>`
            }
          }
        ],
        fileTypeEditor: {
          visible: false,
          fileId: '',
          fileCategory: ''
        },
        gridApiFileDetail: null,
        gridOptionsFileDetail: {
          context: {
            componentParent: this
          }
        },
        columnDefsFileDetail: [
          {
            headerName: this.$t('FileHistory.tagName'),
            field: 'key',
            width: 150
          },
          {
            headerName: this.$t('FileHistory.tagValue'),
            field: 'val',
            width: 200
          }
        ],
        rowDataFileDetail: [],
        isShowingDetailForm: false,
        showDetailTitle: ''
      },
      type: SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code,
      ColumnUtils, ImportConstants,
      innerVisible: false,
      SystemConstants,
      loading: false,
      TYPE_NAMES,
      chargingItemByEqSize: { // 按箱型计费条目
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框触发
          onRowSelected: (event) => {
            this.chargingItemByEqSize.selectedRows = this.chargingItemByEqSize.gridApi.getSelectedRows()
          },
          onRowClicked: event => {
            this.chargingItemByEqSize.selectedRow = event.data
          },
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridCommonTextareaEditor
          }
        },
        selectedRows: [],
        gridApi: null,
        filter: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      chargingItemNotByEqSize: { // 非按箱型计费条目
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框触发
          onRowSelected: (event) => {
            this.chargingItemNotByEqSize.selectedRows = this.chargingItemNotByEqSize.gridApi.getSelectedRows()
          },
          onRowClicked: event => {
            this.chargingItemNotByEqSize.selectedRow = event.data
          },
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          }
        },
        selectedRows: [],
        gridApi: null,
        filter: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      isEdit: false, // 是否 编辑

      chargeItemSet: new Set(),
      form: new Quotation().fillDefaultValue().getData(),
      originForm: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        onRowClicked: event => {
          this.selectedRow = event.data
        },
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridDateTimeEditor
        }
      },
      selectedRows: [],
      selectedRow: null,
      gridApi: null,
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PortPreRateCode'),
          field: 'priceNo',
          colId: 'priceNo',
          width: 200
        }, {
          headerName: this.$t('Pricing.PriceType'),
          field: 'priceMethod',
          colId: 'priceMethod',
          width: 80,
          valueFormatter: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.PRICE_METHODS)
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: SystemConstants.PRICE_METHODS,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          onCellValueChanged: p => this.onPriceMethodCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SideLineType'),
          colId: 'branchLine',
          field: 'branchLine',
          width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.BRANCH_LINES) || ''
          },
          editable: (params) => this.isEdit && params.data.priceMethod === SystemConstants.PRICE_METHOD_BRANCH.code,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: SystemConstants.BRANCH_LINES,
            tagName: 'chineseName',
            tagValue: 'code'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_POL'),
          field: 'pol',
          colId: 'pol',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.getSeaAirPortLabel(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Vendor'),
          field: 'supplier',
          colId: 'supplier',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              customLabel: (item) => `${item.chineseName}` ? `[${item.shortName}]${item.chineseName}` : ' ',
              showCustomLabelInOption: true,
              methodParams: { active: true, subCondition: { seaCmp: true, truckCmp: true, collectionType: 'or' }},
              filterable: true
            }
          }
        },
        {
          headerName: '20GP',
          field: 'gp20',
          colId: 'gp20',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getEqSizeLabel(params.data, 'gp20')
          }
        },
        // {
        //   headerName: '20HC', field: 'hc20', colId: 'hc20', width: 200
        // },
        {
          headerName: '40GP', field: 'gp40', colId: 'gp40', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getEqSizeLabel(params.data, 'gp40')
          }
        },
        {
          headerName: '40HC', field: 'hc40', colId: 'hc40', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getEqSizeLabel(params.data, 'hc40')
          }
        },
        {
          headerName: '45HC', field: 'hc45', colId: 'hc45', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getEqSizeLabel(params.data, 'hc45')
          }
        },
        {
          headerName: '20NOR', field: 'nor20', colId: 'nor20', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getEqSizeLabel(params.data, 'nor20')
          }
        },
        {
          headerName: '40NOR', field: 'nor40', colId: 'nor40', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getEqSizeLabel(params.data, 'nor40')
          }
        },
        {
          headerName: this.$t('Pricing.BeginDateCol'),
          width: 100,
          field: 'beginDate',
          colId: 'beginDate',
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          }
        },
        {
          headerName: this.$t('Pricing.EndDateCol'),
          width: 100,
          field: 'endDate',
          colId: 'endDate',
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          colId: 'remarks',
          width: 150,
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          field: 'createdBy',
          colId: 'createdBy',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DateOfCreation2'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UpdatePerson'), colId: 'modifiedBy', field: 'modifiedBy',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateModified'), colId: 'dateModified', field: 'dateModified',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ]
    }
  },
  computed: {
    fileCloudFileJob() { // 文件操作使用
      return new Quotation(this.form)
    },
    getColumnDefsByEqSize() {
      return this.getChargingItemByEqSizeDefs()
    },
    getColumnDefsNotByEqSize() {
      return this.getChargingItemNotByEqSizeDefs()
    },
    // 负责人才能审批
    canUpdate() {
      return this.isEditAll || this.form.solveUserId === $store.getters.userId + '' || this.$store.getters.isAdmin
    }
  },
  async beforeMount() {
    const context = this
    this.documentManage.set('popFileHistoryDetailFormDialog', function(value) {
      context.fileHistoryHp.popFileHistoryDetailFormDialog(value)
    })
    this.documentManage.set('onFileView', function(value) {
      context.fileHistoryHp.onFileView(value)
    })
  },
  created() {
    this.initChargeItemSet()
    this.initCurrencySet()
  },
  methods: QuotationPrePortLastMileDetail.methods
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.quotation-pre-port-form .lable-blue ::v-deep {
  .el-form-item__label {
    color: blue !important;
  }
}
.quotation-pre-port-form .el-form-item {
  margin-left: 20px;
}
.el-form{
  /deep/ .el-input__inner{
    width: 300px;
  }
  /deep/ .el-input-number {
    width: 300px;
  }
  .length-weight-height {
    /deep/ .el-input-number {
      width: 70px;
    }
    /deep/ .el-input__inner {
      width: 70px;
    }
  }
  /deep/ .with-unit{
    .el-input__inner {
      width: 273px;
    }
    .el-input-number {
      width: 273px !important;
    }
    .el-form-item__content {
      width: 300px;
    }
  }
  /deep/ .area {
    margin-left: 20px;
    .el-input__inner {
      width: 150px;
    }
  }
}
</style>
